import React, { useContext, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Grid  } from "@material-ui/core";
import {setLastTrade} from "store/actions";
import { makeStyles, useTheme } from "@material-ui/styles";
import colors from 'assets/scss/_themes-vars.module.scss';

import {
  createChart,
  createPriceLine,
  CrosshairMode,
} from "lightweight-charts";
import CoinContext from "contexts/CoinContext";
import { useSelector, useDispatch } from "react-redux";
import I from "immutable";
import axios from "axios";
// 1. No duplicates in the CandleStick Time Series
// 2. All time values must be Ascending order (increasing)
// 3. No NULL values in OHLC for that timestamp

const useStyles = makeStyles((theme) => ({
}));

const MarketShareAreaChartCard = () => {
  const chartContainerRef = useRef();
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const cornsilk = (theme.palette.mode === 'dark') ? 'white' : colors.cornsilkDarkTakyon;
  const whiteTakyon = (theme.palette.mode === 'dark') ? colors.whiteLightTakyon : colors.whiteDarkTakyon;
  const green = (theme.palette.mode === 'dark') ? colors.successLightTakyon : colors.successMain;
  const red = (theme.palette.mode === 'dark') ? colors.errorLightTakyon : colors.errorDarkTakyon;
  // const bgcolor = (theme.palette.mode === 'dark') ? '#12151c' : 'white';
  const bgcolor = (theme.palette.mode === 'dark') ? '#15140f' : 'white';

  const chart = useRef();
  const series = useRef();
  const avgLine = useRef();
  const priceLine = useRef();

  const resizeObserver = useRef();
  const { coin } = useContext(CoinContext);

  const ltp = useSelector((state) => {
    return ((state.coins.kraken_asset_pairs_loaded && state.coins.kraken_asset_pairs.get(coin) && state.coins.kraken_asset_pairs.get(coin).ltp) || 0.0);
  });

  const daily = useSelector((state) => {
    return ((state.coins.kraken_asset_pairs_loaded && state.coins.kraken_asset_pairs.get(coin) && state.coins.kraken_asset_pairs.get(coin).daily) || {});
  });

  const portfolio = useSelector((state) => {
    if (state.coins.kraken_asset_pairs) {
      let item = state.coins.kraken_asset_pairs.get(coin);
      if ((item !== undefined) && (item.position !== undefined) && (item.position.remaining_qty !== undefined)) {
        return [
          item.position.remaining_qty.toFixed(2),
          (item.position.remaining_qty * ltp).toFixed(2),
          item.position.realized,
          item.position.unrealized,
          item.position.remaining_avg_price,
        ];
      } else {
        return [0, 0, 0, 0, 0];
      }
    } else {
      return [0, 0, 0, 0, 0];
    }
  });

    const avg_px = portfolio[4];
    let avg_ts = 0;
    let avg_df = 1000000.0;

    const lastTrade = useSelector((state) => {

        if ((state.chart.mapLastTrade) && (state.chart.mapLastTrade.get(coin)))
        {
            return state.chart.mapLastTrade.get(coin);
        }
        let items = [];

        if (state.takyon.mapTrades !== undefined) {
          let count = 0;
          state.takyon.mapTrades.forEach((item, i) => {
            if (item.pair === coin) {
              items.push(item);
            }
          });
        }

        items.sort(function(a, b) {
            return (b.time_ms - a.time_ms);
        });
        return items;
    });


    useEffect(() => {
        {
            // TMD console.log( 'coin: dispatching LastTrade: ' + coin);
            if ( lastTrade.length > 0)
            {
                let len = (lastTrade.length < 20) ? lastTrade.length : 20;

                let trades = [];
                for( let i = 0; i < len; ++i)
                {
                    trades = [...trades, lastTrade[i]];
                }
                console.log(trades);
                dispatch(setLastTrade({coin: coin, trade: trades}));
            }
        }

    }, lastTrade[0]);


  
  /*
  const lastTrade = useSelector((state) => {
    if (state.chart.mapLastTrade) {
      return state.chart.mapLastTrade.get(coin);
    } else {
      return undefined;
    }
  });
  */

  // const mapOrders = useSelector((state) => {
  //   if (state.chart.mapOrders !== undefined) {
  //     return state.chart.mapOrders.get(coin);
  //   } else {
  //     return [];
  //   }
  // });

  // const lwMarkers = useSelector((state) => {
  //   return state.chart.lwMarkers;
  // });

  /*
  const lineData = useSelector((state) => {
     return (state.chart.lineData[coin] || state.chart.lineData["aud/usd"]);
  });
  */

  let lwData =  useSelector((state) => {
    let data = [];
    // TMD console.log( state.chart.chartData);
    Object.keys(state.chart.chartData).map((key) => {
        if ( key === coin)
        {
            // TMD console.log( state.chart.chartData[key]);
            const uniqObj = state.chart.chartData[key];
            let prevTS = 0;
            uniqObj.map((item, index) => {
                if ( item.time > prevTS)
                {
                    prevTS = item.time;
                    data = [...data, item];
                }
            });
        }
    });
    return data;
  });

  useEffect(() => {
    // init chart, do not modify here
    chart.current = createChart(chartContainerRef.current, {
      height: 300,
      layout: {
        backgroundColor: bgcolor,
        textColor: cornsilk,
      },
      grid: {
        vertLines: {
            visible: false,
            color: "#111",
        },
        horzLines: {
            visible: false,
            color: "#111",
        },
      },
      crosshair: {
        vertLine: {
          color: "#333",
          width: 0.1,
          style: 0,
          visible: true,
          labelVisible: true,
        },
        horzLine: {
          color: "#333",
          width: 0.1,
          style: 0,
          visible: true,
          labelVisible: true,
        },
        mode: CrosshairMode.Normal,
      },
      priceScale: {
        borderColor: "#888",
        borderVisible: false,
      },
      alignLabels: true,
      timeScale: {
        rightOffset: 10,
        barSpacing: 8,
        fixLeftEdge: false,
        lockVisibleTimeRangeOnResize: true,
        rightBarStaysOnScroll: true,
        borderVisible: false,
        borderColor: "#888",
        visible: true,
        timeVisible: true,
        secondsVisible: true,
      },
    });

    // upColor: "#4bffb5",
    // downColor: "#ff4976",
    /*
    TODO denys orig
     *
    const candleSeries = chart.current.addCandlestickSeries({
      width: '100%',
      upColor: "#000000",
      downColor: "#ff4976",
      borderUpColor: "#4bffb5",
      borderDownColor: "#ff4976",
      wickUpColor: "#4bffb5",
      wickDownColor: "#ff4976",
    });
    */

    const candleSeries = chart.current.addCandlestickSeries({
      upColor: green,
      downColor: red,
      borderUpColor: green,
      borderDownColor: red,
      wickUpColor: green,
      wickDownColor: red,
    });

    candleSeries.setData([
            {time: 1773166429, open: 9.35, high: 9.35, low: 9.35, close: 9.35},
            {time: 1773166436, open: 9.35, high: 9.36, low: 9.34, close: 9.34},
            {time: 1773166437, open: 9.35, high: 9.35, low: 9.35, close: 9.35},
            {time: 1773166441, open: 9.35, high: 9.35, low: 9.34, close: 9.34},
            {time: 1773166451, open: 9.35, high: 9.35, low: 9.33, close: 9.33},
            {time: 1773166453, open: 9.34, high: 9.34, low: 9.32, close: 9.33},
            {time: 1773166454, open: 9.33, high: 9.33, low: 9.33, close: 9.33},
            {time: 1773166480, open: 9.35, high: 9.36, low: 9.32, close: 9.32},
            {time: 1773166489, open: 9.32, high: 9.32, low: 9.31, close: 9.31},
            {time: 1773166491, open: 9.31, high: 9.32, low: 9.29, close: 9.3},
            {time: 1773166492, open: 9.3, high: 9.32, low: 9.3, close: 9.32},
            {time: 1773166514, open: 9.32, high: 9.37, low: 9.29, close: 9.31},
            {time: 1773166520, open: 9.31, high: 9.32, low: 9.28, close: 9.28},
            {time: 1773166521, open: 9.28, high: 9.29, low: 9.28, close: 9.29},
            {time: 1773166522, open: 9.29, high: 9.3, low: 9.29, close: 9.3},
            {time: 1773166535, open: 9.31, high: 9.32, low: 9.31, close: 9.31},
            {time: 1773166540, open: 9.31, high: 9.34, low: 9.31, close: 9.31}
    ]);


    avgLine.current = candleSeries.createPriceLine({
      price: "0.00",
      color: "orange",
      lineWidth: -1,
      lineStyle: 0,
      axisLabelVisible: true,
      title: "avg",
    });

    series.current = candleSeries;
 
  }, []);

  useEffect(() => {
    //update chart data here
    if (series.current) {
        console.log( 'SET_DATA --------- lwData ' + lwData.length + ', ' + coin);
        series.current.setData(lwData);

        avgLine.current.applyOptions({
            price: avg_px,
        });

        series.current.applyOptions({
            priceFormat: {
                type: 'price',
                precision: 4,
                minMove: 0.0001,
            },
        });

      // let markers = [];

      // series.current.setMarkers(markers);
    }

  }, [lwData, series, ltp]);

  return (
          <div class={classes.chart} ref={chartContainerRef} />
  );
};
export default React.memo(MarketShareAreaChartCard);
